export default __webpack_public_path__ + "static/media/ahm.e14de199.svg";